import { SearchOutlined } from "@ant-design/icons";
import { Button, Input, Tag } from "antd";
import LayoutTableV2 from "app/components/TableV2";
import { EMPTY_VALUE } from "constant";
import { PAGE_ROUTE } from "constant/routes/page";
import { useGetParamsUrl, useHandleSubmitApi } from "hook";
import { EStatusCountTable, IGetPostForPaginateInputModel, IPostDetailOutputModel } from "interfaces";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { createSearchParams, useNavigate } from "react-router-dom";
import { PostServices } from "services";

type P_Props = {};

const PostListPresenter = (props: P_Props) => {
  const navigate = useNavigate();
  const { search } = window.location;
  const dataParams = useGetParamsUrl<{ "cate-post": string }>(search);

  const [activeMenuItem, setActiveMenuItem] = useState<string>(EStatusCountTable.TOTAL);
  const [list, setList] = useState<IPostDetailOutputModel[]>([]);

  const [searchValue, setSearchValue] = useState<string>("");
  const [totalRecord, setTotalRecord] = useState<number>(0);
  const [pageNum, setPageNum] = useState<number>(1);
  const [pageSize] = useState<number>(15);

  useEffect(() => {
    setDefaultFilter();

    // eslint-disable-next-line
  }, [dataParams?.["cate-post"]]);

  useEffect(() => {
    handleFilter();
    // handleFetchCount(category);

    // eslint-disable-next-line
  }, [searchValue, activeMenuItem, dataParams?.["cate-post"], pageNum]);

  const setDefaultFilter = () => {
    setSearchValue("");
    setActiveMenuItem(EStatusCountTable.TOTAL);
  };

  const handleFilter = () => {
    const filter: IGetPostForPaginateInputModel = {
      pageSize: pageSize,
      pageNum: pageNum,
      searchValue: searchValue,
      catePost: dataParams?.["cate-post"],
    };
    getListPost(filter);
  };

  const [getListPost, loading] = useHandleSubmitApi(async (data: IGetPostForPaginateInputModel) => {
    const dataRes = await PostServices.getPost(data);
    if (dataRes) {
      setList(dataRes["data"]);
      setTotalRecord(dataRes["meta"]["totalRecords"]);
      // setPageSize(dataRes["meta"]["totalPages"]);
    }
  });

  return (
    <>
      <LayoutTableV2<IPostDetailOutputModel>
        loading={loading}
        onClick={(record) => {
          navigate({
            pathname: PAGE_ROUTE.ADM_POST_EDIT,
            search: createSearchParams({
              id: record.id,
            }).toString(),
          });
        }}
        header={() => (
          <React.Fragment>
            <div className="layout-list__header__menu" style={{ width: "20rem" }}></div>
            <div className="d-flex">
              <Input
                placeholder="Nhập thông tin tìm kiếm"
                className="mr_1"
                suffix={<SearchOutlined />}
                onChange={_.debounce((e) => {
                  setSearchValue(e.target.value);
                }, 200)}
                // value={searchValue}
              />
              <Button className="btn" size="large" onClick={() => navigate(PAGE_ROUTE.ADM_POST_CREATE)}>
                + Thêm bài viết
              </Button>
            </div>
          </React.Fragment>
        )}
        data={
          list.map((value) => ({
            key: value.id,
            id: value.id,
            title: value.title,
            catePost: value.catePost?.name || EMPTY_VALUE,
            status: value.status,
            createdAt: value.createdAt ? moment(value.createdAt).format("YYYY-MM-DD HH:mm:ss") : EMPTY_VALUE,
          })) as any
        }
        columns={[
          {
            title: "Tiêu đề",
            dataIndex: "title",
            key: "title",
            fixed: "left",
          },
          {
            title: "Danh mục bài viết",
            dataIndex: "catePost",
            key: "catePost",
          },
          {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            render: (value) => {
              let data = {
                color: "green",
                title: "Hiển thị",
              };
              if (!value) {
                data = {
                  color: "magenta",
                  title: "Ẩn",
                };
              }
              return <Tag color={data.color}>{data.title}</Tag>;
            },
          },
          {
            title: "Thời gian tạo",
            dataIndex: "createdAt",
            key: "createdAt",
          },
        ]}
        optionPaginate={{
          numberRecordShow: list.length,
          totalRecord: totalRecord,
          pageNum: pageNum,
          pageSize: pageSize,
          onChangePageNum: (number) => {
            setPageNum(number);
          },
        }}
      />
    </>
  );
};

export default PostListPresenter;
